// Error reporting to Sentry (erest-findings FINDINGS §9.22). This app is
// browser-only (adapter-static), built on the box by `pm2 deploy`.
//
// Read through $env/dynamic/public, not $env/static like the rest of the app:
// a static import of a key missing from .env fails the build, and a missing
// DSN must break nothing.
//
//   PUBLIC_SENTRY_DSN            the project's DSN (public by design: browsers
//                                send it). Absent or empty: nothing is sent.
//   PUBLIC_SENTRY_ENVIRONMENT    "production" on the box; default "development".
//   PUBLIC_SENTRY_TEST_ENABLED   "true" enables /sentry-test (routes/sentry-test).
import { env } from '$env/dynamic/public';

export const sentrySettings = () => {
   const dsn = (env.PUBLIC_SENTRY_DSN || '').trim();
   if (!dsn) return null;
   return { dsn, environment: env.PUBLIC_SENTRY_ENVIRONMENT || 'development' };
};

export const sentryTestEnabled = () => env.PUBLIC_SENTRY_TEST_ENABLED === 'true';
